export const PROGRAM_SUBTITLE =
  'Configure how your practice approaches patient payments, eligibility, and revenue cycle across every visit.';

export const PROGRAM_ITEMS_INTRO_PREFIX = 'Three patent-pending pillars make this program ';

export const PROGRAM_ITEMS_INTRO_BOLD = 'materially different from anything else on the market';

export const PROGRAM_ITEMS = [
  {
    title: 'Eligibility waterfall',
    description:
      'Real-time 270/271 checks cascade through clearinghouses, AI data aggregation, and (soon) agentic portal & payer phone calls to return the most accurate patient portion possible.'
  },
  {
    title: 'Practice-driven customization',
    description:
      'Every threshold, cap, and AI-suggested action is configurable per category, so every patient who walks out has either paid, guaranteed payment, or is awaiting a staff-alerted conversation.'
  },
  {
    title: 'Pre-Auth Healthcare protections',
    description:
      'Card-brand compliant signed authorizations unlock card-on-file charges, chargeback protections, GFE compliance, and automated RCM through IncomeIQueue.'
  }
];

export const WHY_THIS_MATTERS =
  'What follows transforms the No Surprises Act from a compliance burden into a tool that drives more payments and payment arrangements at the time of treatment — while keeping you protected.';

export const ACKNOWLEDGMENTS_INTRO =
  'Review each term below, then confirm you accept them all to continue setup.';

export const ACKNOWLEDGMENT_TERMS = [
  {
    title: 'Exclusive licensing of forms & workflow',
    description:
      "I understand that all healthcare-specific forms, including pre-authorizations and Good Faith Estimate documentation, as well as MediPay's AI-driven payment workflow, are proprietary, copyrighted, and patent-pending, and are exclusively licensed for use within the authorized MediPay processing environment."
  },
  {
    title: 'Customized patient payment approach & outcomes',
    description:
      'I understand that MediPay enables a customized, eligibility-informed patient payment experience designed to increase payments and payment arrangements at the time of treatment, helping reduce or eliminate patient billing costs and accounts receivable balances.'
  },
  {
    title: 'Bundled program participation',
    description:
      'I understand that access to bundled pricing, subsidized services, and system benefits is contingent on active use of MediPay processing, and may be limited or adjusted if participation requirements are not met.'
  }
];

export const ACKNOWLEDGMENT_ERROR = 'Please review and accept the acknowledgments to continue.';
